(() => {
    const PRODUCTS = (window.LANDING === undefined) ? [] : window.LANDING.products;
    const PRODUCTS_CONFIG = (window.LANDING === undefined) ? [] : window.LANDING.config;
    const CART = {};

    const brutto = document.getElementById('bruttonpreis');
    const ihre = document.getElementById('ihre-einsparunger');
    const total = document.getElementById('totalbetrag');
    const totalAmount = document.getElementById('totalamount');
    const rabatt = document.getElementById('rabatt');
    const lieferungCost = document.getElementById('lieferung-cost');

    const totalSummarySync = document.querySelectorAll('[data-sync="total"]');

    const productsSummary = document.getElementById('products-summary');

    if (!brutto || !ihre || !total) return;

    // setup cart
    PRODUCTS.forEach(product => {
        CART[product.id] = { ...product, qty: 0, total: 0 };
    });

    const parseRenderedString = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    };

    const parseFloatFixed = (x, comma) => {
        let xResult = parseFloat(x).toFixed(2);
        if (comma) {
            xResult = parseRenderedString(xResult);
        }
        return xResult;
    };

    // setup totals
    const TOTALS = {
        brutto: 0,
        total: 0,
        ihre: 0,
        rabatt: 0,
        totalAmount: 0,
        lieferung: parseFloat(PRODUCTS_CONFIG['deliveryCost']),
        freeAfter: parseFloat(PRODUCTS_CONFIG['freeDeliveryAfter']),
        type: 0
    };





    const updateCart = (productId, qty) => {
        const { price, pricePromo } = CART[productId];
        const currItem = document.getElementById('order-item-' + productId);
        currItem.value = qty;
        CART[productId] = {
            ...CART[productId],
            qty,
            total: pricePromo ? parseFloatFixed(pricePromo * qty) : parseFloatFixed(price * qty)
        };

        updateTotals();
        renderTotals();
    }

    const renderCart = () => {
        productsSummary.innerHTML = "";

        Object.keys(CART).forEach(key => {

            if (CART[key].total > 0) {
                const currentProduct = CART[key];

                const product = document.createElement('div');
                product.classList.add('d-grid');

                const spanWrapperName = document.createElement('span');

                const spanName = document.createElement('span');
                spanName.textContent = currentProduct.name || 'No name provided';

                const spanCount = document.createElement('span');
                spanCount.classList.add('me-3');
                spanCount.textContent = `${currentProduct.qty} x`;

                // spanWrapperName.appendChild(spanCount);
                product.appendChild(spanCount);
                // spanWrapperName.appendChild(spanName);
                product.appendChild(spanName);

                const { pricePromo, price, qty } = currentProduct;
                const spanPrice = document.createElement('span');
                spanPrice.classList.add('product-price');
                spanPrice.innerHTML = `${productsSummary.dataset.currency || "CHF"} <span class="price-right 8">${parseFloatFixed((price * qty), true)}</span>`;


                // product.appendChild(spanWrapperName);
                product.appendChild(spanPrice);
                productsSummary.appendChild(product);
            }

        });
    }

    const updateTotals = () => {
        let brutto = 0;
        let total = 0;
        let rabatt = 0;
        let deliveryCost = 0.0;

        Object.keys(CART).forEach(key => {
            const { price, qty, pricePromo } = CART[key];
            brutto = brutto + (price * qty);
            total = total + (pricePromo * qty);
        });
        brutto = parseFloatFixed(brutto);
        total = parseFloatFixed(total);

        //console.log(document.querySelector('.delivery-method-input').value);
        //TOTALS.type = (parseInt(document.querySelector('.delivery-method-input').value, 10));

        if (total > TOTALS.freeAfter || TOTALS.type === 1) {
            deliveryCost = 0.0;
            TOTALS.lieferung = 0.0;
        } else {
            TOTALS.lieferung = parseFloat(PRODUCTS_CONFIG['deliveryCost']);
            deliveryCost = TOTALS.lieferung;
        }
        TOTALS.brutto = brutto;
        TOTALS.ihre = parseFloatFixed(total - brutto);
        TOTALS.totalAmount = parseFloatFixed((parseFloat(total) + deliveryCost));
        TOTALS.total = total;
        TOTALS.rabatt = TOTALS.ihre;
    }

    const renderTotals = () => {
        const totalValue = parseRenderedString(`${brutto.dataset.currency || "CHF"} <span class="price-right-mod">${TOTALS.total}</span>`);
        const lieferungCostValue = parseFloatFixed(TOTALS.lieferung, true);
        const ihrneMinus = parseFloatFixed(parseFloat(TOTALS.ihre * -1));
        brutto.innerHTML = parseRenderedString(`${brutto.dataset.currency || "CHF"} <span class="price-right-mod">${TOTALS.brutto}</span>`);
        ihre.innerHTML = parseRenderedString(`${TOTALS.ihre < 0 ? "" : ""} ${brutto.dataset.currency || "CHF"} <span class="price-right-mod">${ihrneMinus}</span>`);
        total.innerHTML = parseRenderedString(`${totalValue}`);
        totalAmount.innerHTML = parseRenderedString(`${brutto.dataset.currency || "CHF"} <span class="price-right 3"> ${TOTALS.totalAmount}</span>`);
        lieferungCost.innerHTML = parseRenderedString(`${brutto.dataset.currency || "CHF"} <span class="price-right 4"> ${lieferungCostValue}</span>`);
        rabatt.innerHTML = parseRenderedString(`${brutto.dataset.currency || "CHF"} <span class="price-right 5"> ${TOTALS.rabatt}</span>`);

        totalSummarySync.forEach(el => {
            el.innerHTML = parseRenderedString(`<span class="price-right 6">${totalValue}</span>`);
        });
    }
    renderTotals();

    const lieferart = document.getElementById('lieferart');
    const lieferartLocation = document.getElementById('ferroFlexForm-location');
    const lieferartInputs = lieferart.querySelectorAll('input[type="radio"]');
    const lieferartSync = document.querySelectorAll('[data-sync="lieferart"]');

    const lieferartSelected = document.querySelector('.delivery-method-input');

    const lieferartLocationSync = document.querySelectorAll('[data-sync="location"]');
    lieferartInputs.forEach(input => input.addEventListener('change', e => {

        if (e.currentTarget.value === 1 && lieferartSelected) {
            lieferartSelected.classList.add('active');
        } else {
            lieferartSelected.classList.remove('active');
        }

        lieferartSync.forEach(el => {
            if (e.currentTarget.value) {
                el.textContent = $(e.currentTarget).parent().find('span').text() || "No name provided";
            } else {
                el.textContent = "";
            }
        });
    }));


    if (parseInt($('.delivery-method-input:checked').val(), 10) === 2) {
        $('.delivery-method-input').trigger('change');
        $(lieferartLocation).prop("disabled", true);
        $(lieferartLocation).parent().css('visibility', 'hidden');
        $('.liferart-in').css('visibility', 'hidden');
        TOTALS.lieferung = 0.0;
    }

    $('.delivery-method-input').on('change', function () {
        if (parseInt(this.value, 10) === 1) {
            $(lieferartLocation).prop("disabled", false);
            $(lieferartLocation).parent().css('visibility', 'visible');
            $('.liferart-in').css('visibility', 'visible');
            $('.liferart-location').css('visibility', 'visible');
            TOTALS.type = 1;
            updateTotals();
            renderTotals();
        } else {
            $(lieferartLocation).prop("disabled", true);
            $(lieferartLocation).parent().css('visibility', 'hidden');
            $('.liferart-in').css('visibility', 'hidden');
            $('.liferart-location').css('visibility', 'hidden');
            TOTALS.type = 0;
            //TOTALS.lieferung = parseFloat(PRODUCTS_CONFIG['deliveryCost']);
            updateTotals();
            renderTotals();
        }

    })

    $(lieferartLocation).on('change', function (e) {
        lieferartLocationSync.forEach(el => {
            el.textContent = $(e.currentTarget).find('option:selected').text() || "No name provided";
        });
    });


    const inputs = document.querySelectorAll('input.input-number');

    inputs.forEach(el => setupCustomInput(el));

    function setupCustomInput(input) {
        const wrapper = document.createElement('div');
        wrapper.classList.add('input-styled');

        input.style.display = 'none';

        const styledValue = document.createElement('div');
        styledValue.classList.add('d-flex', 'justify-content-center', 'align-items-center', 'p-4', 'bg-white', 'input-value', 'text-black');

        const minus = document.createElement('button');
        minus.classList.add('btn', 'btn-grey-v-light', 'btn-large', 'text-brand-red');
        minus.textContent = "-";

        const plus = document.createElement('button');
        plus.classList.add('btn', 'btn-grey-v-light', 'btn-large', 'text-brand-red');
        plus.textContent = "+";

        const updateStyledValue = (value) => {
            styledValue.textContent = value;
            updateCart(input.dataset.productId, parseInt(value));
            renderCart();
        }
        updateStyledValue(input.value);

        plus.addEventListener('click', e => {
            const { value, max } = input;
            const parsedValue = parseInt(value, 10);
            const parsedMax = parseInt(max, 10);

            if (parsedValue === parsedMax) return;
            input.value = parsedValue + 1;
            updateStyledValue(input.value);
        });

        minus.addEventListener('click', e => {
            const { value } = input;
            const parsedValue = parseInt(value, 10);

            if (parsedValue < 1) return;
            input.value = parsedValue - 1;
            updateStyledValue(input.value);
        });

        wrapper.appendChild(minus);
        wrapper.appendChild(styledValue);
        wrapper.appendChild(plus);

        input.parentNode.appendChild(wrapper);

        input.addEventListener('change', e => {
            updateStyledValue(e.currentTarget.value);
        });


    }

    const urlParams = new URLSearchParams(window.location.search);

    //?anrede=Luke&vorname=Skywalker&email=email@email.com&adresse=Poland&plz=plzvalue&phone=48600600600&kundennumber=testval&rt=rttest
    // form
    const form = document.querySelector('.landingecomm-form');
    const DOM = {
        form: form,
        formFields: {
            anrede: form.querySelector('[data-field="anrede"]'),
            vorname: form.querySelector('[data-field="vorname"]'),
            name: form.querySelector('[data-field="name"]'),
            email: form.querySelector('[data-field="email"]'),
            strasse: form.querySelector('[data-field="strasse"]'),
            plz: form.querySelector('[data-field="plz"]'),
            phone: form.querySelector('[data-field="phone"]'),
            kundennummer: form.querySelector('[data-field="kundennummer"]'),
            ort: form.querySelector('[data-field="ort"]'),
            salutation: form.querySelector('[data-field="salutation"]'),
            nameFirst: form.querySelector('[data-field="nameFirst"]'),
            nameLast: form.querySelector('[data-field="nameLast"]'),
            street: form.querySelector('[data-field="street"]'),
            zip: form.querySelector('[data-field="zip"]'),
            city: form.querySelector('[data-field="city"]'),
            customerNumber: form.querySelector('[data-field="customerNumber"]'),
        }
    };

    Object.keys(DOM.formFields).forEach(key => {
        //const urlValue = urlParams.get(`${key}`) || "";
        if (!DOM.formFields[key]) return;
        const sync = document.querySelectorAll(`[data-sync="${key}"]`);
        if (sync) {
            sync.forEach(el => {
                if ($(DOM.formFields[key]).data('field-select') > 0) {
                    el.textContent = $(DOM.formFields[key]).find('option:selected').text();
                } else {
                    el.textContent = DOM.formFields[key].value;
                }
            });

            if (key === 'zip') {
                DOM.formFields[key].addEventListener('keypress', e => {

                    if (e.currentTarget.value.length == 0) {
                        if (e.key == 0) {
                            e.preventDefault();
                        }
                    }

                    if (e.currentTarget.value.length == 1) {
                        if (e.currentTarget.value == 9) {
                            if (e.key == 7 || e.key == 8 || e.key == 9) {
                                e.preventDefault();
                            }
                        }
                    }

                    if (!e.key.match(/^[0-9]$/) || e.currentTarget.value.length >= 4) {
                        e.preventDefault();
                    };
                });
            }


            DOM.formFields[key].addEventListener('change', e => {
                sync.forEach(el => {
                    if ($(DOM.formFields[key]).data('field-select') > 0) {
                        el.textContent = $(e.target).find('option:selected').text();
                    } else {
                        el.textContent = e.target.value;
                    }
                });
            });
        }
    });

    const submitButton = form.querySelector('[type="submit"]');
    const formInputs = form.querySelectorAll('input');
    const formSelects = form.querySelectorAll('select');

    const formRadioInputs = form.querySelectorAll('.delivery-method-input');
    const lieferartSection = form.querySelector('#lieferart');

    const addValidationMessage = (node, message) => {
        const text = document.createElement('span');
        text.classList.add('validation-message');
        text.style.color = 'red';
        text.style.display = 'block';
        text.textContent = message;

        if ($(node).hasClass('force-after')) {
            $(node).parent().after(text);
        } else {
            node.after(text);
        }

    }

    const validateField = (field, message) => {

        if ((field.dataset?.field) && field.dataset?.field === 'zip') { // additional validation for PLZ
            const regex = /^[0-9]{4}$/;

            if (!(field.value).match(regex)) {
                addValidationMessage(field, message);
                return false;
            };
        }

        if (!field.validity.valid) {
            addValidationMessage(field, message);
            return false;
        }
        return true;
    };

    const onSubmit = (e) => {
        let validated = true;

        form.querySelectorAll('.validation-message').forEach(el => el.remove());
        formInputs.forEach(el => {
            if (el.type !== 'radio') {
                if (!validateField(el, el.dataset.validationError || 'Required field')) {
                    validated = false;
                }
            }
        });

        formSelects.forEach(el => {
            if (!validateField(el, el.dataset.validationError || 'Required field')) {
                validated = false;
            }
        });

        // lieferart
        let lieferartValidated = false;
        formRadioInputs.forEach(el => {
            if (el.checked && !lieferartValidated) {
                lieferartValidated = true;

            }
        });

        if (!lieferartValidated || ((parseInt($('#ferroFlexForm-location').val(), 10) === 0) && parseInt($('.delivery-method-input').filter(":checked").val()) === 1)) {
            addValidationMessage(lieferartSection, formRadioInputs[0]?.dataset?.validationError || "Bitte wählen Sie eine Liefermethode");
            validated = false;
        }

        if (!validated) {
            e.preventDefault();
            let scrollTo = false;
            if ($(".validation-message").first().length) {
                let obj = $(".validation-message").first().closest('.form-group');
                if (typeof obj.offset() == "undefined") {
                    obj = $(".validation-message").first();
                }
                scrollTo = obj.offset().top;
            }
            if (scrollTo) {
                $('html, body').animate({
                    scrollTop: scrollTo - 350
                }, 1500);
            }
            console.log('❌ form is not valid');
        }
    };

    // form.addEventListener('submit', onSubmit);
    submitButton.addEventListener('click', onSubmit);


})();

$(document).ready(() => {

    function scrollToElement() {
        let offsetApp = 150;
        if (window.matchMedia('(max-width: 767px)').matches) {
            offsetApp = 200;
        }
        let rawId = window.location.hash.replace('product-', 'lc-product-');
        //$(window.location.hash).addClass(window.location.hash);
        if ($(rawId).length > 0) {
            $("html, body").animate({ scrollTop: $(rawId).offset().top - offsetApp });
        }
    }

    if (window.location.hash.length > 0) {
        scrollToElement();
    }
    $(window).on('hashchange', function (e) {
        scrollToElement();
    });


});
